import React, { useEffect } from 'react'
import { Controller } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { 
  Paper, 
  Stack,
  Typography,
  Divider,
  TextField,
  Grid,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton
} from '@mui/material'
import CreatableSelect from 'react-select/creatable';

import { IoMdAdd } from "react-icons/io";
import { FaArrowCircleLeft, FaArrowCircleRight } from "react-icons/fa";
import { BiSave } from "react-icons/bi";
import { MdDeleteForever, MdEdit } from "react-icons/md";

import { removeAccents } from '../../../utils';

import swal from 'sweetalert';
import { Table } from 'reactstrap';
import { fetchInsertOrUpdateSemanaAlmuerzoCombos } from '../../../redux/Cafeteria/CafeteriaSlice';

export const RegistroCombosComidaRRHHPage = (
  {
    categoriasComidasState = [], 
    form, 
    diasSemanas, 
    stepPosition: {diaId, position},
    setStepPosition,
    combosWatch = [],
    setOpenEditComida,
    funcAgregarNuevaComida,
    semanaId
  }
) => {

  // ? HOOK-DISPATCH
  const dispatch = useDispatch();

  // ? HOOK-FORM
  const { 
    setValue, 
    control,  
    formState: { errors }, 
    handleSubmit
  } = form;

  // * DESESTRUCTURACION DE DATOSS
  const { descripcion : dia = '', id} = diasSemanas.find(x => x.id === diaId) ?? {};

  // * DIA NORMALIZADO
  const diaNormalized = removeAccents(dia).toLowerCase();

  // * FUNCION PARA AGREGAR COMBO,
  const saveCombo = (data) => {

    try {
      // * DESESTRUCTURACION DE LA DATA.
      const { guarnicion, acompañamiento, ensalada, numeracion, combos } = data;
      
      // * VALIDACION DE NUMERACION, SI YA EXISTE SE MOSTRARA UN MENSAJE AL USUARIO PARA QUE REVISE.
      const validateNumeracionExist = combosWatch?.some(x => x.numeracion === numeracion);

      // * VALIDACION PARA QUE AL MOMENTO DE GUARDAR UN NUEVO COMBO SE HAYA SELECCIONADO AL MENOS UNA CATEGORIA.
      if(Object.keys(guarnicion).length === 0 && Object.keys(acompañamiento).length === 0 && Object.keys(ensalada).length === 0){
        swal("Error!", "Debe seleccionar al menos una comida.", "error");
        return; 
      }
      
      if(validateNumeracionExist){
        swal("Error!", "No puede agregar este combo porque la numeración ya existe, favor validar.", "error");
        return; 
      }
      
      // * CREACION DE ESTRUCTURA DEL NUEVO OBJETO DEL COMBO.
      const comboNew = {
        id: 0,
        numeracion,
        semanaId,
        diaId: id,
        fechaCreacion: new Date(),
        comidas: [guarnicion, acompañamiento, ensalada]
      }      

      const combosUpdate = [...combos[diaNormalized], comboNew];

      setValue(`combos.${diaNormalized}`, combosUpdate);

      // * RESETEAR VALORES DE REGISTRO.
      setValue('guarnicion', {});
      setValue('acompañamiento', {});
      setValue('ensalada', {});
    } catch (error) {
      console.error(error)
    }
  
  }

  // * FUNCION PARA PASAR DE PAGINAS.
  const nextPage = () => {
   
    // * RESETEAR VALORES DE REGISTRO.
    setValue('guarnicion', {});
    setValue('acompañamiento', {});
    setValue('ensalada', {});
    setValue('numeracion', 1);

    // * PASAR AL SIGUIENTE DIA.
    setStepPosition({diaId: diaId + 1, position: position + 1 })
  }
  
  // * ENVIAR DATA A BACK-END
  const saveData = () => {
    
    // * LISTA DE COMBOS FILTRANDO AQUELLOS OBJETOS VACIOS.
    const combos = Object.keys(combosWatch)
    .map(item => combosWatch[item]) // Extrae los valores del objeto
    .flat() // Aplana los arrays
    .map(x => ({
        ...x, 
        comidas: Array.isArray(x.comidas) 
        ? x.comidas.filter(comida => Object.keys(comida).length > 0) // Filtra los objetos vacíos
          : []
        }))
        .filter(x => x.comidas.length > 0) ?? [];
        
        if(combos.length === 0){
          return;
        }
        
        // * LISTA DE COMBOS CON EL FORMATO VALIDO PARA EL SERVIDOR.
        let listaCombos = [];
        
        // * CICLO PARA DARLE EL FORMATO CORRECTO A LA DATA QUE SERA ENVIADA AL
        // * BACK-END
        for (let i = 0; i < combos.length; i++) {
          
          const combo = combos[i];
          
          let comboNew = {...combo};
          comboNew.comidas = [];
          
          for (let x = 0; x < combo?.comidas?.length; x++) {
            const {id, categoriaAlmuerzoId, descripcion} = combo?.comidas[x];
            
            const addComida =  {
              id: combo?.comidas[x]?.nuevo ? 0 : id,
              categoriaAlmuerzoId,
              descripcion,
              estado: true,
            }
            
            comboNew.comidas.push(addComida);
          }
          
          listaCombos.push(comboNew);
        }
        
        // * ENVIO DE DATA AL BACK-END.
        dispatch(fetchInsertOrUpdateSemanaAlmuerzoCombos(listaCombos));
    }
      
    
    // * FUNCION PARA ELIMINAR COMBO SELECCIONADO.
    const deleteCombo = (combo) => {
      swal({
        title: `Esta seguro de eliminar el combo #${combo.numeracion}?`,
        text: "Una vez anulado, no podrá modificar el permiso.",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((answer) => {
      if (answer) {
        const comboFilter = combosWatch.filter(x => x.numeracion !== combo.numeracion);
        setValue(`combos.${diaNormalized}`, comboFilter);
      } 
    });
    }
    
    // * ORDENAR EL ARRAY DE OBJETOS DE LA SELECCION DE MENU SEMANAL RRHH.
    const ordenDias = ["lunes", "martes", "miercoles", "jueves", "viernes"];
  
    // * ORDENANDO LISTA
    const diasOrdenados = Object.fromEntries(
      Object.entries(combosWatch)
          .sort((a, b) => ordenDias.indexOf(a[0]) - ordenDias.indexOf(b[0]))
    );

    // ? HOOK-EFFECT PARA ASIGNAR LA NUMERACION Y SE VAYA INCREMENTANDO
    useEffect(() => {
      if(combosWatch.length > 0){
        setValue('numeracion', combosWatch[combosWatch.length - 1].numeracion + 1);
      }
      else{
        setValue('numeracion', 1)
      }
    }, [combosWatch])
    
    return (
      <Paper>
        <Stack p={3} minHeight='80%'>
          <Typography variant='h6'>{ position < 5 ? dia : "Resumen del Menú de la semana"}</Typography>
          <Divider />

            {
              position < 5 ?
              <>
                <form onSubmit={handleSubmit(saveCombo)}>
                  <Stack mt={2} mb={2} className='col-5'>
                    <Typography fontWeight='bold'>Ensalada</Typography>
                    <Controller
                    control={control}
                    name="ensalada"
                    render={({ field }) => (
                      <CreatableSelect 
                      defaultValue={{}}
                      placeholder='Seleccionar comida'
                      onCreateOption={(e) => funcAgregarNuevaComida({value: e, categoriaAlmuerzoId: 3})}
                      isClearable 
                      options={categoriasComidasState.find(x => x.id === 3)?.comidas ?? []}
                      getOptionLabel={(option) => option.descripcion}
                      getOptionValue={(option) => option.id}
                      onChange={(opt, actionMeta) => {
                        // Si limpian o queda sin selección -> guarda {}
                        if (actionMeta?.action === 'clear' || opt == null) {
                          field.onChange({});
                        } else {
                          field.onChange(opt);
                        }
                      }}
                      value={
                        field.value?.id
                          ? (categoriasComidasState.find(x => x.id === 3)?.comidas ?? [])
                              .find(x => x.id === field.value.id) ?? null
                          : null
                      }
                      />
                    )}
                    />
                  </Stack>
                
                  <Stack mb={2} className='col-5'>
                    <Typography fontWeight='bold'>Acompañamiento</Typography>
                    <Controller
                    control={control}
                    name="acompañamiento"
                    render={({ field }) => (
                      <CreatableSelect 
                      placeholder='Seleccionar comida'
                      onCreateOption={(e) => funcAgregarNuevaComida({value: e, categoriaAlmuerzoId: 2})}
                      isClearable 
                      options={categoriasComidasState.find(x => x.id === 2)?.comidas ?? []}
                      getOptionLabel={(option) => option.descripcion}
                      getOptionValue={(option) => option}
                      onChange={(opt, actionMeta) => {
                        // Si limpian o queda sin selección -> guarda {}
                        if (actionMeta?.action === 'clear' || opt == null) {
                          field.onChange({});
                        } else {
                          field.onChange(opt);
                        }
                      }}
                      value={
                        field.value?.id
                          ? (categoriasComidasState.find(x => x.id === 2)?.comidas ?? [])
                              .find(x => x.id === field.value.id) ?? null
                          : null
                      }
                      />
                    )}
                    />
                  </Stack>
                
                  <Stack mb={2} className='col-5'>
                    <Typography fontWeight='bold'>Guarnición</Typography>
                    <Controller
                    control={control}
                    name="guarnicion"
                    render={({ field }) => (
                      <CreatableSelect 
                      placeholder='Seleccionar comida'
                      onCreateOption={(e) => funcAgregarNuevaComida({value: e, categoriaAlmuerzoId: 1})}
                      isClearable 
                      options={categoriasComidasState.find(x => x.id === 1)?.comidas ?? []}
                      getOptionLabel={(option) => option.descripcion}
                      getOptionValue={(option) => option.id}
                      onChange={(opt, actionMeta) => {
                        // Si limpian o queda sin selección -> guarda {}
                        if (actionMeta?.action === 'clear' || opt == null) {
                          field.onChange({});
                        } else {
                          field.onChange(opt);
                        }
                      }}
                      value={
                        field.value?.id
                          ? (categoriasComidasState.find(x => x.id === 1)?.comidas ?? [])
                              .find(x => x.id === field.value.id) ?? null
                          : null
                      }
                      />
                    )}
                    />
                  </Stack>

                  <Stack display='flex' className='col-12'>
                    <Typography fontWeight='bold'>Numeración</Typography>
                    <Grid container>
                      <Grid item xs={5}>
                        <Controller 
                        control={control}
                        name='numeracion'
                        render={({field}) => (
                          <TextField 
                          sx={{minWidth: '100%'}}
                          type='number'
                          variant='outlined' 
                          onChange={(e) => field.onChange(e)}
                          value={field.value}
                          
                          />
                        )}
                        />

                        <p hidden={!errors?.numeracion?.message} className='text-danger'>{errors?.numeracion?.message}</p>
                      </Grid>

                      <Grid item xs={2}>
                        <button type='submit' className='btn btn-primary-mem ms-2'><IoMdAdd fontSize={22} /></button>
                      </Grid>
                    </Grid>
                  </Stack>
                </form>

                <TableContainer component={Paper} sx={{mt: 2}}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{fontWeight: 'bold'}}>Combo</TableCell>
                          <TableCell sx={{fontWeight: 'bold'}}>Comida</TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {
                          combosWatch?.length > 0 ?
                            combosWatch.map((item, index) => (
                              <TableRow key={index}>
                                <TableCell>
                                  {item.numeracion}
                                </TableCell>
                                <TableCell>
                                {item.comidas && item.comidas.length > 0 
                                  ? item.comidas
                                      .filter(comida => comida.descripcion) // Filtra comidas sin descripción
                                      .map(comida => comida.descripcion)
                                      .join(", ") 
                                  : ""}
                                </TableCell>
                                 
                                 <TableCell>
                                 <IconButton onClick={() => deleteCombo(item)}>
                                    <MdDeleteForever color='red' />
                                  </IconButton>
                                 <IconButton onClick={() => setOpenEditComida({open: true, combo: item, diaNormalized})}>
                                    <MdEdit color='#003876' />
                                  </IconButton>
                                 </TableCell>

                              </TableRow>
                            ))
                          : 
                          <>
                            <TableRow>
                              <TableCell colSpan={3} align="center">
                                No hay registros
                              </TableCell>
                            </TableRow>
                          </>
                        }
                      </TableBody>
                    </Table>
                </TableContainer>
              </>

              : <>

                  <Table component={Paper} sx={{ mt: 2 }}>
                    {
                      Object.keys(diasOrdenados).map((dia, index) => (
                        <React.Fragment key={index}>
                          {/* Encabezado del día */}
                          <TableRow>
                            <TableCell colSpan={3} sx={{ backgroundColor: '#003876', p: 1}}>
                              <Typography fontSize={16} fontWeight="bold" color="white">
                                {diasSemanas.find(x => removeAccents(x.descripcion).toLowerCase() === dia)?.descripcion}
                              </Typography>
                            </TableCell>
                          </TableRow>

                          {/* Tabla de combos para el día */}
                          <TableRow>
                            <TableCell colSpan={3}>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Combo</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Comida</TableCell>
                                    <TableCell></TableCell>
                                  </TableRow>
                                </TableHead>

                                <TableBody>
                                  {combosWatch[removeAccents(dia)]?.length > 0 ? (
                                    combosWatch[removeAccents(dia)].map((item, index2) => (
                                      <TableRow key={index2}>
                                        <TableCell>{item.numeracion}</TableCell>
                                        <TableCell>
                                          <Typography>
                                            {item.comidas?.length
                                              ? item.comidas
                                                  .filter(comida => comida.descripcion?.trim()) // Filtra descripciones vacías
                                                  .map(comida => comida.descripcion)
                                                  .join(", ")
                                              : "Sin comidas"}
                                          </Typography>
                                        </TableCell>
                                        <TableCell></TableCell>
                                      </TableRow>
                                    ))
                                  ) : (
                                    // Mensaje de "No hay registros" correctamente estructurado
                                    <TableRow>
                                      <TableCell colSpan={3} align="center">
                                        No hay registros
                                      </TableCell>
                                    </TableRow>
                                  )}
                                </TableBody>
                              </Table>
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      ))
                    }
                  </Table>
              </>
            }

           <div className='mt-4 d-flex justify-content-end'>
              <button style={{marginRight: 4}} hidden={position === 0} onClick={() => setStepPosition({diaId: diaId - 1, position: position - 1 })} className='btn btn-primary-mem'><FaArrowCircleLeft style={{marginBottom: 4}} /> Anterior</button>
              <button hidden={position === 5} onClick={() =>  nextPage()} className='btn btn-primary-mem'>Siguiente <FaArrowCircleRight style={{marginBottom: 4}} /> </button>
              <button hidden={position < 5} onClick={() => saveData()} className='btn btn-primary-mem'>Guardar <BiSave style={{marginBottom: 3}} fontSize={22} /></button>
            </div>

        </Stack> 
    </Paper>
  )
}
